"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OctaviFilterResultInner = exports.OctaviFilterResult = void 0;
var _reactI18next = require("react-i18next");
const OctaviFilterResultInner = props => props.value === 'no_data' ? props.t('octavi:NoData') : !Number.isNaN(props.value) ? new Intl.NumberFormat(props.i18n.language).format(props.value) : props.t('octavi:Error');
exports.OctaviFilterResultInner = OctaviFilterResultInner;
const OctaviFilterResult = exports.OctaviFilterResult = (0, _reactI18next.withTranslation)(['main', 'octavi'])(OctaviFilterResultInner);